import React from "react";
import pic3 from "../Assets/pic3.png";
import Typewriter from "typewriter-effect";
import Intro from "./Intro";
function Body() {
 
  return (
    <>
     <div className="body">
      <div className="main">
        <img alt="Me" src={pic3}></img>

        <div className="intro">
          <h1 className="hi">Hi There! <span class="wave">&#128075;&#127995;</span> </h1>
          <h1>
            {" "}
            I'M <strong> Syed Wajahat Ali </strong>
          </h1>
         
          <Typewriter className="type"
            options={{
              autoStart: true,
              loop: true,
            }}
            onInit={(typewriter) => {
              
              typewriter
            

                .typeString("Mobile Apps Developer")
                .pauseFor(1000)
                .deleteAll()
                .typeString("MERN Stack Developer")
                .start()
                .pauseFor(1000)
                .deleteAll()
                .typeString("Android Enthusiast")
                .start()
                .pauseFor(1000)
                .deleteAll()
                .typeString("Backend Engineer")
                .start()
                .pauseFor(1000);
            }}
            
          />
        </div>
      </div>
    </div>
    <Intro></Intro>    
    </>
    

  );
}

export default Body;
